// extracted by mini-css-extract-plugin
export default {"subjectsContainer":"TopSubjects_subjectsContainer__dDDA2","pharmacyContainer":"TopSubjects_pharmacyContainer__hUBwX","pharmacyTopic":"TopSubjects_pharmacyTopic__WDRDW"};